import { z } from "zod";

import { defaultItem, defaultUrl, itemSchema, urlSchema } from "../shared";

// Schema
export const awardSchema = itemSchema.extend({
  title: z.string().min(1).max(50),
  awarder: z.string().max(50),
  date: z.string(),
  summary: z.string().max(100),
  url: urlSchema,
});

// Type
export type Award = z.infer<typeof awardSchema>;

export const defaultAward: Award = {
  ...defaultItem,
  title: "",
  awarder: "",
  date: "",
  summary: "",
  url: defaultUrl,
};
